import { configureStore } from '@reduxjs/toolkit'
import sourcesReducer from './reducers/SourcesSlice.js'
import loadedReducer from './reducers/LoadedSlice.js'
import drawReducer from './reducers/DrawSlice.js'
import {dataReducer} from './reducers/DataSlice.js'
import paramReducer from './reducers/ParamSlice.js'
import colorsReducer from './reducers/ColorsSlice.js'
import itemReducer from './reducers/ItemSlice.js'
import menuOpenReducer from './reducers/MenuOpenSlice.js'
import tooltip2Reducer from './reducers/Tooltip2Slice.js'
import tooltip1Reducer from './reducers/Tooltip1Slice.js'
import popupReducer from './reducers/PopupSlice.js'
import mapReadyReducer from './reducers/MapReadySlice.js'


const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
    reducer: {
        sources: sourcesReducer,
        loaded: loadedReducer,
        draw: drawReducer,
        item:itemReducer,
        tooltip2:tooltip2Reducer,
        tooltip1:tooltip1Reducer,
        popup:popupReducer,
        data: dataReducer,
        menuOpen: menuOpenReducer,
        param:paramReducer,
        colors:colorsReducer,
        mapReady:mapReadyReducer,
       
      },

  })

  export default store ;